import Sidebar from "./Sidebar";
import Header from "./Header/Header";
import "./layoutStyle.css";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  Divider,
  Drawer,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ImageIcon from "@mui/icons-material/Image";
import DescriptionIcon from "@mui/icons-material/Description";
import FolderIcon from "@mui/icons-material/Folder";
import React, { useContext } from "react";
import { SidebarContext } from "../../contexts/SidebarContext";

const AccentHeaderLayout = (props) => {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);

  const [hamburgerMenu, setHamburgerMenu] = React.useState(false);

  const toggleDrawer = () => setHamburgerMenu((prev) => !prev);

  return (
    <div className="outer-grid">
      {/*<div style={{height: '50px', backgroundColor: '#EEEEEE'}}>1</div>*/}
      <div className="inner-grid">
        {/*<div style={{border: '2px solid darkblue'}}>2</div>*/}

        <Sidebar />

        {/* The inside of the drawer */}

        {hamburgerMenu && (
          <Sidebar toggleDrawer={toggleDrawer} hamburgerMenu={hamburgerMenu} />
        )}

        <div className="content">
          <Header toggleDrawer={toggleDrawer} />

          <div className="maincontainer">{props.children}</div>
          {/*<div style={{border: '1px solid brown', width: '100px', height: '100%'}}>3</div>*/}
        </div>
      </div>
    </div>
  );
};

export default AccentHeaderLayout;
